module.exports = __webpack_public_path__ + "static/media/tree2.e914ba0e.png";